import { FilterBar, FilterToggle } from '../../../Filter'

import {
  getDocFlowMappingResultTableBarFilters,
  getDocFlowMappingResultTableToggleFilters,
  getDocFlowMappingResultTableToggleFilterValues,
  getDocFlowMappingResultTableTogglePermanentFilters,
} from './DocFlowMappingResultTableFilterBar.utils'

import * as styles from './DocFlowMappingResultTableFilterBar.module.css'

function DocFlowMappingResultTableFilterBar({
  availableFilters,
  filterValues,
  isSkeleton,
  setFilterValues,
  ...restProps
}) {
  function getHandleChangeToggle(name) {
    return isOn => {
      setFilterValues(
        getDocFlowMappingResultTableToggleFilterValues({
          filterValues,
          isOn,
          name,
        })
      )
    }
  }

  return (
    <div className={styles.DocFlowMappingResultTableFilterBar}>
      <FilterBar
        {...restProps}
        availableFilters={getDocFlowMappingResultTableBarFilters(
          availableFilters
        )}
        filterValues={filterValues}
        getPermanentFilters={getDocFlowMappingResultTableTogglePermanentFilters}
        isSkeleton={isSkeleton}
        setFilterValues={setFilterValues}
      />
      {getDocFlowMappingResultTableToggleFilters(availableFilters).map(
        filter => (
          <FilterToggle
            className={styles.toggle}
            disabled={isSkeleton}
            filter={filter}
            isOn={filterValues?.[filter.name]}
            key={filter.name}
            qaName={filter.name}
            onClick={getHandleChangeToggle(filter.name)}
          />
        )
      )}
    </div>
  )
}

export default DocFlowMappingResultTableFilterBar
